import config, {weather_base_url} from "../config"
const baseUrl = config.weather_base_url + "district/"
export default {
    // 获取省份列表
    provinceList: {
        url: baseUrl + "provinceList",
        type: "get",
    },
    // 获取城市列表
    cityList: {
        url: baseUrl + "cityList",
        type: "get",
    },
    // 根据ID获取县级区划信息
    get: {
        url: baseUrl + "get",
        type: "get",
    },
    // 获取所有县级区划列表
    findAll: {
        url: baseUrl + "findAll",
        type: "get",
    },
    // 根据城市代码获取县级区划列表
    listByCityCode: {
        url: baseUrl + "listByCityCode",
        type: "get",
    },
    // 根据省份代码获取县级区划列表
    listByProvinceCode: {
        url: baseUrl + "listByProvinceCode",
        type: "get",
    },
    // 分页查询县级区划
    page: {
        url: baseUrl + "page/{page}/{limit}",
        type: "get",
    },
    // 保存或更新县级区划信息
    save: {
        url: baseUrl + "save",
        type: "post",
    },
    // 删除县级区划
    delete: {
        url: baseUrl + "delete",
        type: "get",
    },
    // 查询县级区划列表
    list: {
        url: baseUrl + "list",
        type: "post",
    }
}
